'use strict';

import MD5 from 'crypto-js/md5';

import AWS from 'aws-sdk';

export function hexToBinary(hex) {
  return parseInt(hex, 16).toString(2).padStart(8, '0');
}

export function calculateMD5(text) {
  return MD5(text).toString();
}

export function calculateMD5Binary(text) {
  const hash = calculateMD5(text);
  let binary = '';
  for (let i = 0; i < hash.length; i += 2) {
    binary += hexToBinary(hash.substr(i, 2));
  }
  return binary;
}

export function getFileBase64By64Bytes(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file.slice(0, 64));
    reader.onload = e => {
      const result = e?.target?.result;
      if (result instanceof ArrayBuffer) {
        const uint8Array = new Uint8Array(result);
        let binaryString = '';
        uint8Array.forEach(byte => {
          binaryString += String.fromCharCode(byte);
        });
        const base64String = btoa(binaryString);
        resolve(base64String);
      } else {
        resolve('');
      }
    };
    reader.onerror = () => {
      resolve('');
    };
  });
}

export function getFileExtension(filename) {
  const regex = /(?:\.([^.]+))?$/;
  const match = String(filename).match(regex);
  return match?.[1] ?? '';
}

export function binaryToString(binary) {
  let string = '';
  for (let i = 0; i < binary.length; i += 8) {
    string += String.fromCharCode(parseInt(binary.substr(i, 8), 2));
  }
  return string;
}

export function calculateMD5Base64(text) {
  const binary = calculateMD5Binary(text);
  const string = binaryToString(binary);
  return btoa(string);
}

export function ensureHttps(endpoint) {
  // 正则表达式匹配 http:// 或 https:// 协议头
  return endpoint.replace(/^https?:\/\//, 'https://') || `https://${endpoint}`;
}

export function fileUpload(token, file, onProgress, onSuccess, onError) {
  //const token = res.data
  const REGION = token.bucketInfo.region;
  const endpoint = token.bucketInfo.endpoint;
  const ACCESS_KEY_SECRET = token.stsToken.accessKeySecret;
  const BUCKET_NAME = token.bucketInfo.bucketName;
  const ACCESS_KEY_ID = token.stsToken.accessKeyId;
  const STS_TOKEN = token.stsToken.securityToken;
  const KEY_INFO = token.keyInfo.key;

  AWS.config.update({
    region: REGION,
    endpoint: ensureHttps(endpoint),
    accessKeyId: ACCESS_KEY_ID,
    secretAccessKey: ACCESS_KEY_SECRET,
    sessionToken: STS_TOKEN,
  });
  const s3 = new AWS.S3();
  const params = {
    Bucket: BUCKET_NAME,
    Key: KEY_INFO,
    Body: file,
  };
  const options = {
    partSize: 5 * 1024 * 1024, // 10 MB
    queueSize: 1,
  };
  const upload = s3.upload(params, options);
  upload.on('httpUploadProgress', progress => {
    const percent = Math.round((progress.loaded / progress.total) * 100);
    // console.log(`上传进度: ${percent}%`)
    onProgress(percent);
  });

  upload.send((err, data) => {
    if (err) {
      onError(err);
      console.log('视频上传失败，请稍后重试');
    } else {
      onSuccess(data);
      // console.log('视频上传成功')
    }
  });
}
